export const SCENARIO_DATA_VERSION = 1;

export const HIGH_ZOOM = 12;
export const MID_HIGHER_ZOOM = 15;
export const MED_HIGH_ZOOM = 16;
export const INTERMEDIATE_ZOOM = 17;
export const MEDIUM_ZOOM = 18;
export const LOW_ZOOM = 19;

// Zoom levels at which the port furniture becomes visible, for scenario and overview layers alike.
export const FENDER_VISIBLE_ZOOM = 14; // drawn from this level and in
export const BOLLARD_VISIBLE_ZOOM = 14; // drawn above this level
export const BERTH_RULER_VISIBLE_ZOOM = 15; // ruler + chainage labels, drawn above this level
export const BOLLARD_LABEL_VISIBLE_ZOOM = MED_HIGH_ZOOM; // drawn above this level

export const BLACK_RGB: [number, number, number] = [0, 0, 0];
export const RED_RGB: [number, number, number] = [255, 0, 0];
export const WHITE_RGB: [number, number, number] = [255, 255, 255];
export const FENDER_BLUE_FADED: [number, number, number, number] = [13, 57, 88, 70];
export const FENDER_BORDER: [number, number, number, number] = [55, 71, 79, 70];
export const BOLLARD_BLUE: [number, number, number] = [55, 71, 79];
export const BOLLARD_BLUE_FADED: [number, number, number, number] = [207, 216, 220, 190];
export const DISABLED_RED: [number, number, number] = [202, 48, 58];
export const DISABLED_RED_FADED: [number, number, number, number] = [202, 48, 58, 190];
export const WINCH_GREEN: [number, number, number] = [165, 214, 167];

export const DISTANCE_RULER_MAX_METER_MARK = 100;
export const SLIDER_CONTAINER_BUFFER = 2;
export const MA_ROUND_DECIMALS = 1;

export const CONTAINER_LENGTH = 12.192;
export const CONTAINER_HEIGHT = 2.591;
export const CONTAINER_WIDTH = 2.438;

export const MOORING_ARRANGEMENT_DROPDOWN_CUSTOMISED = 'Customised';

export const SCENARIO_LIST_TABS = {
  FORECAST: 'forecast',
  PLANNING: 'planning',
} as const;

export type ScenarioListTab = typeof SCENARIO_LIST_TABS[keyof typeof SCENARIO_LIST_TABS];

export const getScenarioListTab = (isDynamic: boolean): ScenarioListTab =>
  isDynamic ? SCENARIO_LIST_TABS.FORECAST : SCENARIO_LIST_TABS.PLANNING;

export const ETAB_ETDB_MIN_TIME_INTERVAL_IN_MINUTES = 10;

export const CHARACTER_SET = [
  ' ',
  '!',
  '"',
  '#',
  '$',
  '%',
  '&',
  '(',
  ')',
  '*',
  '+',
  '-',
  '.',
  '/',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  ':',
  ';',
  '<',
  '=',
  '>',
  '?',
  '@',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'ß',
  'Ä',
  'Ö',
  'Ü',
  '[',
  ']',
  '^',
  '_',
  '`',
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
  'ü',
  'ä',
  'ö',
  '{',
  '|',
  '}',
  '~',
];